import { joinPaths } from './util';

export const HOMEPAGE_URL = 'https://www.useindigo.com';
export const MEDIA_BASE_URL = 'https://media.useindigo.com';

export function getMediaUrl(path: string) {
  return joinPaths(MEDIA_BASE_URL, path);
}
